// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_HOMEPAGE = "Sp\u00e4\u0165 na hlavn\u00fa str\u00e1nku";
export const PROFILE_PRODUCTS_TITLE = "Produkty na mojom profile";
export const USER_STROLLERS_MY_STROLLERS = "Moje ko\u010d\u00edky";
